








































































































































































































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import md5 from "js-md5";
import Icone from "../ui-component/icone.vue";

@Component({ components: { Icone } })
export default class NavigationList extends mixins(MobileMixin) {
  @Prop() public isHeader!: boolean;

  public onglet: string = "";

  get path() {
    return this.$route.path.substring(1);
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get clientM5(): string {
    let cli = this.$store.getters["getClient"];
    cli = cli.toUpperCase();
    cli = md5(cli);
    return cli;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get isApp(): boolean {
    return this.$store.getters["getApp"];
  }

  get loading(): boolean {
    return this.$store.getters["login/loading"];
  }
}
